<template>
  <div>
    <!-- 날짜 -->
    <div class="absolute top-0 flex items-center gap-4" :class="[!isPrint && 'py-6']" style="left: calc(190px + 3rem)">
      <div v-if="isPrint" class="flex items-center justify-center gap-3">
        <p class="print-input">{{ form.headerDate | moment("YYYY") }}</p>
        년
        <p class="print-input">{{ form.headerDate | moment("M") }}</p>
        월
      </div>
      <month-picker v-else class="inline-block" v-model="form.headerDate" :readonly="board.readonly || !enableSave" :disableYM="disableYM">
        <template v-slot="{ inputValue, year, month, onClick }">
          <div class="flex items-center justify-center gap-3 cursor-pointer" @click="onClick">
            <ml-input style="width: 100px" class="header-month" :class="[(board.readonly || !enableSave) && 'readonly']" :value="year" readonly />
            <p>년</p>
            <ml-input style="width: 100px" class="header-month" :class="[(board.readonly || !enableSave) && 'readonly']" :value="month" readonly />
            <p>월</p>
          </div>
        </template>
      </month-picker>
    </div>

    <!--기본정보-->
    <FieldSelectModule v-model="form.stdInfo" :board="this.board" :isPrint="isPrint || !!postId" @selectField="selectField" class="mb-28px" />

    <!-- 안전·보건예산 항목 -->
    <div class="mb-28px">
      <h5><i class="dot"></i>안전·보건예산 항목</h5>
      <div v-if="!board.readonly && enableSave" class="flex justify-between items-end gap-4">
        <p class="text-sm font-medium">※ 항목 편집 시, 가급적 같은 항목을 사용하도록 주의해주시기 바랍니다. (기존에 작성했던 항목과 다르게 띄어쓰기나 오타가 있을 경우 새 데이터로 처리될 수 있습니다.)</p>
        <div v-if="!isEdit">
          <vs-button color="secondary" type="border" @click="isEdit = true"> <feather-icon icon="EditIcon" style="width: 18px" class="align-middle mr-1" /> 항목 편집하기 </vs-button>
        </div>
        <div v-else class="flex justify-end gap-4" style="min-width: 465px">
          <vs-button color="secondary" type="border" @click="isEdit = false"> <feather-icon icon="EditIcon" style="width: 18px" class="align-middle mr-1" /> 항목 편집하기 종료 </vs-button>
          <vs-button color="secondary" @click="addItem">항목추가</vs-button>
          <vs-button color="secondary" type="border" @click="removeItem">선택삭제</vs-button>
        </div>
      </div>

      <table class="mt-4">
        <colgroup>
          <col v-if="isEdit" width="40" style="background: #f9f9f9" />
          <col v-else style="background: #f9f9f9" />
        </colgroup>
        <thead>
          <th v-if="isEdit"><vs-checkbox :value="0 < form.list.length && checkListIds.length === form.list.length" @click.native="checkAll" /></th>
          <th>항목별</th>
          <th>예산</th>
          <th>당월 사용금액</th>
          <th>누계</th>
          <th>집행률</th>
        </thead>
        <tbody>
          <tr v-for="item in form.list" :key="item.id">
            <td v-if="isEdit" class="p-0"><vs-checkbox :vs-value="item.id" v-model="checkListIds" /></td>
            <td>
              <span v-if="isPrint" class="print-input">{{ item.label }}</span>
              <ml-input v-else-if="isEdit" class="w-full" v-model="item.label" :readonly="board.readonly || !enableSave" />
              <p v-else class="text-center">{{ item.label }}</p>
            </td>
            <td>
              <span v-if="isPrint" class="print-input">{{ item.budget }}</span>
              <comma-input v-else class="w-full" v-model="item.budget" :readonly="board.readonly || !enableSave || isEdit" @blur="calculateInputs" />
            </td>
            <td>
              <span v-if="isPrint" class="print-input">{{ item.month }}</span>
              <comma-input v-else class="w-full" v-model="item.month" :readonly="board.readonly || !enableSave || isEdit" @blur="calculateInputs" />
            </td>
            <td>
              <span v-if="isPrint" class="print-input">{{ item.month + item.prev }}</span>
              <comma-input v-else class="w-full" :value="item.month + item.prev" readonly />
            </td>
            <td>
              <span v-if="isPrint" class="print-input">{{ item.rate }}</span>
              <ml-input v-else class="w-full" v-model="item.rate" readonly />
            </td>
          </tr>
          <tr class="tr-totla">
            <td v-if="isEdit" class="p-0"></td>
            <td>누계</td>
            <td>
              <span v-if="isPrint" class="print-input">{{ form.total.budget }}</span>
              <comma-input v-else class="w-full" v-model="form.total.budget" readonly />
            </td>
            <td>
              <span v-if="isPrint" class="print-input">{{ form.total.month }}</span>
              <comma-input v-else class="w-full" v-model="form.total.month" readonly />
            </td>
            <td>
              <span v-if="isPrint" class="print-input">{{ form.total.total }}</span>
              <comma-input v-else class="w-full" v-model="form.total.total" readonly />
            </td>
            <td>
              <span v-if="isPrint" class="print-input">{{ form.total.rate }}</span>
              <ml-input v-else class="w-full" v-model="form.total.rate" readonly />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <FileUploadModule v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import moment from "moment";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    tab: Object,
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    totalInputB() {
      return this.computeInputTotal(this.form.inputB);
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return 494;
    },
    postId() {
      return this.$route.params.postId ? parseInt(this.$route.params.postId) : null;
    },
    enableSave() {
      return this.form.stdInfo && !!this.form.stdInfo.field_name;
    },
    headerDate() {
      return this.form.headerDate;
    },
  },
  data() {
    return {
      disableYM: [],
      isEdit: false,
      checkListIds: [],
      postHeaderDate: "",
      postFormList: null,

      form: {
        headerDate: "",

        stdInfo: {},
        fileList: [],

        list: [
          { id: 1, label: "학교시설 내진보강", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 2, label: "학교 석면 해체·제거", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 3, label: "과학실 안전관리강화", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 4, label: "직업계고 산업안전보건 온라인교육", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 5, label: "직업계고 산업안전보건 및 노동인권교육", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 6, label: "현장실습 안전지원 사업비", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 7, label: "산업안전보건 관리감독자교육", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 8, label: "안전보건교육", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 9, label: "산업안전보건위원회", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 10, label: "산업보건의 운영지원", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 11, label: "산업안전보건점검", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 12, label: "산업안전보건 작업환경측정", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 13, label: "급식종사자 폐암건강검진", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 14, label: "중대재해예방관리", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 15, label: "안전보건개선비", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 16, label: "산업안전보건관리 용역", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 17, label: "산업안전보건 관리감독자교육", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 18, label: "학교급식위생 안전관리", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 19, label: "재난위험시설 개선", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 20, label: "제2·3종시설물 정기안전점검", budget: 0, month: 0, prev: 0, rate: 0.0 },
          { id: 21, label: "40년이상 학교시설 정밀점검", budget: 0, month: 0, prev: 0, rate: 0.0 },
        ],
        total: {
          budget: 0,
          month: 0,
          total: 0,
          rate: 0.0,
        },
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);

        if (this.postId && value.stdInfo.field_name && !this.postFormList) {
          this.postFormList = JSON.parse(JSON.stringify(value.list));
          this.postHeaderDate = value.headerDate;
          this.loadListBoard(false);
        }
      },
    },
    headerDate: {
      deep: true,
      handler() {
        this.form.fullHeaderDate = moment(`${this.form.headerDate}-1`).format("YYYY-MM-DD");
        this.setDatas();
      },
    },
  },
  methods: {
    selectField(data) {
      if (!data) return;
      this.loadListBoard(true);
    },
    async loadListBoard(setHeaderDate) {
      const projectId = this.projectId;
      const boardId = 494;
      const page = 1;
      const perPage = 1000;
      const keyword = [`content$body.stdInfo.field_id*${this.form.stdInfo.field_id}`];

      await this.$store.dispatch("board/LOAD_POST_LIST", {
        boardId,
        projectId,
        page,
        perPage,
        keyword,
      });
      const rows = [...JSON.parse(JSON.stringify(this.$store.state.board.list))];

      if (0 < rows.length) {
        // 비활성화 날짜 추출
        const _disableYM = rows.map((item) => {
          const data = JSON.parse(item.post_content).body;
          return data.headerDate;
        });

        this.disableYM = this.postId ? _disableYM.filter((_dym) => _dym !== this.postHeaderDate) : _disableYM;

        // disalbeYM에 없는 달 찾기
        let tempDate = moment().format("YYYY-M");
        while (this.disableYM.includes(tempDate)) {
          tempDate = moment(tempDate).subtract(1, "month").format("YYYY-M");
        }
        if (setHeaderDate) this.form.headerDate = tempDate;
      } else if (setHeaderDate) this.form.headerDate = moment().format("YYYY-MM");
    },
    // LIST 데이터 추출
    setDatas() {
      if (!!this.postId && !!this.postHeaderDate && this.postHeaderDate === this.form.headerDate) {
        this.form.list = JSON.parse(JSON.stringify(this.postFormList));
        this.calculateInputs();
        return;
      }

      const rows = [...JSON.parse(JSON.stringify(this.$store.state.board.list))];
      if (0 < rows.length) {
        // 현재 년도에 해당하면서 선택된 달 이전의 데이터 추출
        const yearDatas = [];
        rows.map((item) => {
          const data = JSON.parse(item.post_content).body;
          const dHD = moment(data.headerDate);
          const fHD = moment(this.form.headerDate);
          if (dHD.diff(fHD) < 0 && dHD.format("YYYY") === fHD.format("YYYY")) yearDatas.push(data.list);
        });

        // 현재 년도에 해당하는 데이터가 있을 경우
        if (0 < yearDatas.length) {
          this.form.list = yearDatas.reduce((acc, cur) => {
            cur.map((_c) => {
              const findLabelIndex = acc.findIndex((_a) => _a.label === _c.label);
              if (0 <= findLabelIndex) {
                acc[findLabelIndex].prev += parseInt(_c.month);
              } else {
                acc.push({ id: acc.length + 1, label: _c.label, prev: parseInt(_c.month), budget: 0, month: 0, total: 0, rate: 0.0 });
              }
            });
            return acc;
          }, []);
        } else {
          this.resetList();
        }
      } else {
        this.resetList();
      }

      this.calculateInputs();
    },
    checkAll(e) {
      if (e.target.checked) this.checkListIds = this.form.list.map((item) => item.id);
      else this.checkListIds = [];
    },
    addItem() {
      const lastId = 0 < this.form.list.length ? this.form.list[this.form.list.length - 1].id : 1;
      this.form.list.push({
        id: lastId + 1,
        label: "",
        budget: 0,
        month: 0,
        total: 0,
        rate: 0.0,
      });
      this.calculateInputs();
    },
    removeItem() {
      this.form.list = this.form.list.filter((item) => !this.checkListIds.includes(item.id));
      this.checkListIds = [];
      this.calculateInputs();
    },

    calculateInputs() {
      this.form.list.forEach((item) => {
        item.total = parseInt(item.month);
        if (!!item.total && !!item.budget) item.rate = item.total / item.budget;
        else item.rate = 0.0;
      });

      this.form.total.budget = this.form.list.reduce((acc, cur) => acc + parseInt(cur.budget), 0);
      this.form.total.month = this.form.list.reduce((acc, cur) => acc + parseInt(cur.month), 0);
      this.form.total.total = this.form.list.reduce((acc, cur) => acc + parseInt(cur.month) + parseInt(cur.prev), 0);
      if (!!this.form.total.total && !!this.form.total.budget) this.form.total.rate = Math.floor((this.form.total.total / this.form.total.budget) * 10000) / 10000;
      else this.form.total.rate = 0.0;
    },
    resetList() {
      this.form.list = [
        { id: 1, label: "학교시설 내진보강", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 2, label: "학교 석면 해체·제거", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 3, label: "과학실 안전관리강화", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 4, label: "직업계고 산업안전보건 온라인교육", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 5, label: "직업계고 산업안전보건 및 노동인권교육", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 6, label: "현장실습 안전지원 사업비", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 7, label: "산업안전보건 관리감독자교육", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 8, label: "안전보건교육", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 9, label: "산업안전보건위원회", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 10, label: "산업보건의 운영지원", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 11, label: "산업안전보건점검", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 12, label: "산업안전보건 작업환경측정", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 13, label: "급식종사자 폐암건강검진", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 14, label: "중대재해예방관리", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 15, label: "안전보건개선비", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 16, label: "산업안전보건관리 용역", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 17, label: "산업안전보건 관리감독자교육", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 18, label: "학교급식위생 안전관리", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 19, label: "재난위험시설 개선", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 20, label: "제2·3종시설물 정기안전점검", budget: 0, month: 0, prev: 0, rate: 0.0 },
        { id: 21, label: "40년이상 학교시설 정밀점검", budget: 0, month: 0, prev: 0, rate: 0.0 },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.header-month::v-deep {
  input {
    background: white;
  }
  &.readonly input {
    background: #fafafa !important;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 400;
    border: 1px solid #cdcdcd;
  }

  th {
    text-align: center;
    padding: 16px 0;
    background: #f9f9f9;
  }
  td {
    padding: 6px;
  }

  .tr-totla {
    background: #f9f9f9;
    td {
      text-align: center;
    }
  }
}

::v-deep .con-vs-checkbox {
  justify-content: right !important;
}
</style>
